module.exports = __webpack_public_path__ + "img/icon-nav1_hov.9769b3a9.png";